var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to-top",attrs:{"role":"button"}},[_c('div',{staticClass:"clickable",on:{"click":_vm.toTop}},[_c('Icon',{attrs:{"name":"keyboard_arrow_up"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }